import * as React from "react";
import {
  buildQueryString,
  updateActiveFormInstance,
  useFormInstanceField,
} from "../../../../../store/base";

import { constants } from "../../../../../store/inspectionErrands";

import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../../Details/OverviewInfo/styles";
import { InnerBox } from "../../../../sharedStyles";
import { TextButton } from "../../../Base/Buttons";

import { useFilteredErrandComponents } from "../../../../../store/errandComponents";
import RoomOverview from "../../../../TechnicalManagement/Component/RoomOverview";
import { useDispatch } from "react-redux";
import { getComponentQueryKeyFromType } from "../../../ReportErrand/ChapterForm/Chapters/Component";
import { getComponentsByRooms } from "../../../../TechnicalManagement/utils";
import { InfoBox } from "../../../../Displays";
import LocalTableSelectField from "src/components/Forms/Base/Fields/LocalTableSelectField";
import ApartmentTable from "src/components/Tables/Apartments/FullTableNewVersion";
import IndustrialPremisesTable from "src/components/Tables/IndustrialPremises/FullTableNewVersion";
import CommonAreaTable from "src/components/Tables/CommonArea/FullTable";
import BrfPremisesTable from "src/components/Tables/BrfPremises/FullTable";
import ParkingSpotsTable from "src/components/Tables/Parking/ParkingSpots/FullTable";

const TYPES = {
  APARTMENT: 1,
  INDUSTRIAL_PREMISES: 2,
  COMMON_AREA: 3,
  BRF_PREMIS: 4,
  PARKING_SPOT: 5,
};

const getAttrNameFromType = (type) => {
  if (type === TYPES.APARTMENT) return "apartment";
  if (type === TYPES.INDUSTRIAL_PREMISES) return "industrial_premises";
  if (type === TYPES.COMMON_AREA) return "common_area";
  if (type === TYPES.BRF_PREMIS) return "brf_premis";
  if (type === TYPES.PARKING_SPOT) return "parking_spot";
};

export default () => {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  const [selectedType, setSelectedType] = React.useState(null);

  const formInstance = useFormInstanceField({
    storeName,
    fieldKey: "",
  });

  React.useEffect(() => {
    if (formInstance?.apartment) {
      setSelectedType(TYPES.APARTMENT);
    } else if (formInstance?.industrial_premises) {
      setSelectedType(TYPES.INDUSTRIAL_PREMISES);
    } else if (formInstance?.common_area) {
      setSelectedType(TYPES.COMMON_AREA);
    } else if (formInstance?.brf_premis) {
      setSelectedType(TYPES.BRF_PREMIS);
    } else if (formInstance?.parking_spot) {
      setSelectedType(TYPES.PARKING_SPOT);
    }
  }, []);

  const componentQueryKey = getComponentQueryKeyFromType(selectedType);
  const attrName = getAttrNameFromType(selectedType);

  const selectedSetting = useFormInstanceField({
    storeName,
    fieldKey: "setting",
  });

  const selectedPremises = useFormInstanceField({
    storeName,
    fieldKey: attrName,
  });

  const componentQ = buildQueryString({
    [componentQueryKey || "id__in"]: selectedPremises?.id || "-1",
  });
  const [components, componentsLoading] =
    useFilteredErrandComponents(componentQ);

  const componentsByRoom = React.useMemo(() => {
    return getComponentsByRooms({ components });
  }, [components]);

  const handleSetPremises = (premises) => {
    if (!premises) {
      dispatch(
        updateActiveFormInstance({
          storeName,
          data: {
            [attrName]: null,
          },
        })
      );

      return;
    }

    dispatch(
      updateActiveFormInstance({
        storeName,
        data: {
          [attrName]: premises,
        },
      })
    );
  };

  React.useEffect(() => {
    if (selectedSetting && selectedSetting?.category != null) {
      switch (selectedSetting.category) {
        case 0: {
          setSelectedType(TYPES.APARTMENT);
          return;
        }
        case 1: {
          setSelectedType(TYPES.INDUSTRIAL_PREMISES);
          return;
        }
        case 4: {
          setSelectedType(TYPES.COMMON_AREA);
          return;
        }
        case 5: {
          setSelectedType(TYPES.PARKING_SPOT);
          return;
        }
        case 6: {
          setSelectedType(TYPES.BRF_PREMIS);
          return;
        }
        default:
          return;
      }
    }
  }, []);

  if (!selectedSetting)
    return (
      <InnerBox>
        <OverviewTitleWrapper>
          <OverviewTitleWithSubtitleWrapper>
            <OverviewTitle small>Komponent</OverviewTitle>
            <OverviewSubtitle>
              Välj vilken komponent ärendet gäller. Välj objekt för att filtrera
              fram rätt komponent.
            </OverviewSubtitle>
          </OverviewTitleWithSubtitleWrapper>
        </OverviewTitleWrapper>

        <hr />

        <InfoBox
          title="Besiktningstyp saknas"
          text="Välj typ av besiktning först för att välja objekt"
        />
      </InnerBox>
    );

  if (selectedPremises) {
    return (
      <InnerBox>
        {!formInstance?._dontClear && (
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle small>
                Valt objekt: {selectedPremises?.str_representation}
              </OverviewTitle>
              <OverviewSubtitle>
                <TextButton
                  title="Byt objekt"
                  clicked={() => {
                    dispatch(
                      updateActiveFormInstance({
                        storeName,
                        data: {
                          apartment: null,
                          industrial_premises: null,
                          brf_premis: null,
                          parking_spot: null,
                          common_area: null,
                        },
                      })
                    );
                  }}
                  iconType="close"
                />
              </OverviewSubtitle>
            </OverviewTitleWithSubtitleWrapper>
          </OverviewTitleWrapper>
        )}
        <InnerBox>
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle small>Komponenter i objekt</OverviewTitle>
            </OverviewTitleWithSubtitleWrapper>
          </OverviewTitleWrapper>
          {Object.keys(componentsByRoom)?.length > 0 ? (
            <RoomOverview
              rooms={componentsByRoom}
              selectOnly
              onSelect={() => {}}
              isParkingSpot={selectedType === TYPES.PARKING_SPOT}
            />
          ) : (
            <InnerBox>
              {componentsLoading
                ? "Laddar..."
                : "Detta objekt innehåller inga komponenter att besikta."}
            </InnerBox>
          )}
        </InnerBox>
      </InnerBox>
    );
  }

  return (
    <>
      <OverviewTitleWrapper>
        <OverviewTitleWithSubtitleWrapper>
          <OverviewTitle>Objekt att besikta</OverviewTitle>
          <OverviewSubtitle>
            Välj vilken objekt som ska besiktas
          </OverviewSubtitle>
        </OverviewTitleWithSubtitleWrapper>
      </OverviewTitleWrapper>

      <hr />

      {!selectedType && (
        <InnerBox>
          <OverviewTitleWrapper>
            <OverviewTitle small>Välj typ av objekt</OverviewTitle>
          </OverviewTitleWrapper>
          {(selectedSetting?.category === 0 ||
            selectedSetting?.category == null) && (
            <TextButton
              extraStyle={{ marginBottom: 12 }}
              title="Lägenhet"
              iconType="arrow"
              iconPlacement="right"
              clicked={() => setSelectedType(TYPES.APARTMENT)}
            />
          )}

          {(selectedSetting?.category === 1 ||
            selectedSetting?.category == null) && (
            <TextButton
              extraStyle={{ marginBottom: 12 }}
              title="Lokal"
              iconType="arrow"
              iconPlacement="right"
              clicked={() => setSelectedType(TYPES.INDUSTRIAL_PREMISES)}
            />
          )}

          {(selectedSetting?.category === 4 ||
            selectedSetting?.category == null) && (
            <TextButton
              extraStyle={{ marginBottom: 12 }}
              title="Gemensamt utrymme"
              iconType="arrow"
              iconPlacement="right"
              clicked={() => setSelectedType(TYPES.COMMON_AREA)}
            />
          )}

          {(selectedSetting?.category === 5 ||
            selectedSetting?.category == null) && (
            <TextButton
              extraStyle={{ marginBottom: 12 }}
              title="Parkeringsplats"
              iconType="arrow"
              iconPlacement="right"
              clicked={() => setSelectedType(TYPES.PARKING_SPOT)}
            />
          )}

          {(selectedSetting?.category === 6 ||
            selectedSetting?.category == null) && (
            <TextButton
              extraStyle={{ marginBottom: 12 }}
              title="Bostadsrätt"
              iconType="arrow"
              iconPlacement="right"
              clicked={() => setSelectedType(TYPES.BRF_PREMIS)}
            />
          )}
        </InnerBox>
      )}

      {selectedType && !selectedPremises && (
        <InnerBox>
          <TextButton
            title="Byt typ av objekt"
            iconType="arrow-back"
            extraStyle={{ marginBottom: 12 }}
            clicked={() => {
              handleSetPremises(null);
              setSelectedType(null);
            }}
          />
          <OverviewTitleWrapper>
            <OverviewTitle small>Välj objekt</OverviewTitle>
          </OverviewTitleWrapper>

          {selectedType === TYPES.APARTMENT && (
            <div className="grid grid-cols-2 gap-6 mb-6">
              <LocalTableSelectField
                value={selectedPremises}
                TableComponent={ApartmentTable}
                title="Lägenhet"
                placeholder="Välj lägenhet..."
                description="Välj objekt för att visa komponenter"
                onChange={(val) => handleSetPremises(val)}
              />
            </div>
          )}

          {selectedType === TYPES.INDUSTRIAL_PREMISES && (
            <div className="grid grid-cols-2 gap-6 mb-6">
              <LocalTableSelectField
                value={selectedPremises}
                TableComponent={IndustrialPremisesTable}
                title="Lokal"
                placeholder="Välj lokal..."
                description="Välj objekt för att visa komponenter"
                onChange={(val) => handleSetPremises(val)}
              />
            </div>
          )}

          {selectedType === TYPES.COMMON_AREA && (
            <div className="grid grid-cols-2 gap-6 mb-6">
              <LocalTableSelectField
                value={selectedPremises}
                TableComponent={CommonAreaTable}
                title="Gemensamt utrymme"
                placeholder="Välj utrymme..."
                description="Välj objekt för att visa komponenter"
                onChange={(val) => handleSetPremises(val)}
              />
            </div>
          )}

          {selectedType === TYPES.BRF_PREMIS && (
            <div className="grid grid-cols-2 gap-6 mb-6">
              <LocalTableSelectField
                value={selectedPremises}
                TableComponent={BrfPremisesTable}
                title="Bostadsrätt"
                placeholder="Välj bostadsrätt..."
                description="Välj objekt för att visa komponenter"
                onChange={(val) => handleSetPremises(val)}
              />
            </div>
          )}

          {selectedType === TYPES.PARKING_SPOT && (
            <div className="grid grid-cols-2 gap-6 mb-6">
              <LocalTableSelectField
                value={selectedPremises}
                TableComponent={ParkingSpotsTable}
                title="Fordonsplats"
                placeholder="Välj fordonsplats..."
                description="Välj objekt för att visa komponenter"
                onChange={(val) => handleSetPremises(val)}
              />
            </div>
          )}
        </InnerBox>
      )}
    </>
  );
};
